// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

var swiper = new Swiper(".calendarSwiper", {
  spaceBetween: 32,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
  },
});


var swiper = new Swiper(".commentsSwiper", {
  spaceBetween: 32,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
  },
});

var swiper = new Swiper(".teamSwiper", {
  spaceBetween: 32,
  centeredSlides: true,
  
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
      initialSlide: 1,
      spaceBetween: 42,
    },
    992: {
      slidesPerView: 3,
      initialSlide: 1,
      spaceBetween: 42,
    },
  },
});

document.addEventListener("DOMContentLoaded", function () {
  const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
      if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target); // opzionale: rimuove l'osservazione una volta attivata
      }
  });
  }, {
      root: null, // viewport
      rootMargin: "0px 0px -200px 0px", // top, right, bottom, left
      threshold: 0
  });

  document.querySelectorAll('.timeline .content').forEach(el => {
      observer.observe(el);
  });
});